export default __webpack_public_path__ + "static/media/map-pc.00aea76c.jpg";